'use strict';

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var varint = require('varint');

var BufferList = require('bl/BufferList'); // Decode a chunk and yield an _array_ of decoded messages


module.exports = function (source) {
  return function () {
    var _decode = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var decoder, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, msgs;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              decoder = new Decoder();
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context.prev = 3;
              _iterator = _asyncIterator(source);

            case 5:
              _context.next = 7;
              return _awaitAsyncGenerator(_iterator.next());

            case 7:
              _step = _context.sent;
              _iteratorNormalCompletion = _step.done;
              _context.next = 11;
              return _awaitAsyncGenerator(_step.value);

            case 11:
              _value = _context.sent;

              if (_iteratorNormalCompletion) {
                _context.next = 21;
                break;
              }

              chunk = _value;
              msgs = decoder.write(chunk);

              if (!msgs.length) {
                _context.next = 18;
                break;
              }

              _context.next = 18;
              return msgs;

            case 18:
              _iteratorNormalCompletion = true;
              _context.next = 5;
              break;

            case 21:
              _context.next = 27;
              break;

            case 23:
              _context.prev = 23;
              _context.t0 = _context["catch"](3);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 27:
              _context.prev = 27;
              _context.prev = 28;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context.next = 32;
                break;
              }

              _context.next = 32;
              return _awaitAsyncGenerator(_iterator.return());

            case 32:
              _context.prev = 32;

              if (!_didIteratorError) {
                _context.next = 35;
                break;
              }

              throw _iteratorError;

            case 35:
              return _context.finish(32);

            case 36:
              return _context.finish(27);

            case 37:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 23, 27, 37], [28,, 32, 36]]);
    }));

    function decode() {
      return _decode.apply(this, arguments);
    }

    return decode;
  }()();
};

var Decoder = /*#__PURE__*/function () {
  function Decoder() {
    var _this = this;

    _classCallCheck(this, Decoder);

    this._buffer = new BufferList(); // optimization to allow varint to take a BufferList (well a proxy to)

    this._bufferProxy = new Proxy({}, {
      get: function get(_, prop) {
        return prop[0] === 'l' ? _this._buffer[prop] : _this._buffer.get(parseInt(prop));
      }
    });
    this._headerInfo = null;
  }
  /**
   * @param {Buffer|BufferList} chunk
   * @returns {object[]} An array of message objects
   */


  _createClass(Decoder, [{
    key: "write",
    value: function write(chunk) {
      if (!chunk || !chunk.length) return [];

      this._buffer.append(chunk);

      var msgs = [];

      while (true) {
        if (!this._headerInfo) {
          try {
            this._headerInfo = this._decodeHeader(this._bufferProxy);
          } catch (_) {
            break; // We haven't received enough data yet
          }
        }

        var _this$_headerInfo = this._headerInfo,
            id = _this$_headerInfo.id,
            type = _this$_headerInfo.type,
            length = _this$_headerInfo.length,
            offset = _this$_headerInfo.offset;
        var bufferedDataLength = this._buffer.length - offset;
        if (bufferedDataLength < length) break; // not enough data yet

        msgs.push({
          id: id,
          type: type,
          data: this._buffer.shallowSlice(offset, offset + length)
        });

        this._buffer.consume(offset + length);

        this._headerInfo = null;
      }

      return msgs;
    }
    /**
     * Attempts to decode the message header from the buffer
     * @private
     * @param {Buffer} data
     * @returns {*} message header (id, type, offset, length)
     */

  }, {
    key: "_decodeHeader",
    value: function _decodeHeader(data) {
      var h = varint.decode(data);
      var offset = varint.decode.bytes;
      var length = varint.decode(data, offset);
      offset += varint.decode.bytes;
      return {
        id: h >> 3,
        type: h & 7,
        offset: offset,
        length: length
      };
    }
  }]);

  return Decoder;
}();